<template lang="pug">
    .z-deal-customer-view
        .z-deal-customer-title {{$props.title}}
        .z-deal-customer-view__value(v-for="item in Object.values(data.fields)" v-if="item.show")
            .z-deal-customer-view__value-label {{item.label + ': '}}
            .z-deal-customer-view__value-value {{(item.value) ? item.value : 'Не указанно'}}
</template>
<script>
    export default {
        name: 'z-deal-customer-view',
        components: {},
        props: {
            customer: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            deal: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            title: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'sender',
                validator: (val) => ['sender', 'recipient', 'payer', 'applicant'].includes(val)
            }
        },
        data() {
            return {}
        },
        created() {},
        watch: {},
        computed: {
            data() {
                let isUL = (parseInt(this.$props.customer.type) == 1 || parseInt(this.$props.customer.type) == 3);
                let contacts = [];
                let showAddress = (this.$props.type == 'sender' || this.$props.type == 'recipient');
                if (this.$props.customer.attached_contacts) contacts = this.$props.customer.attached_contacts.map(item => {
                    return item.name ? (item.name + ': ' + item.phone) : item.phone;
                });

                let data = {
                    title: {
                        title: '',
                        value: 'Отправитель'
                    },
                    fields: {
                        type: {
                            code: 'type',
                            label: 'Тип контрагента',
                            value: isUL ? 'Юридическое лицо' : 'Физическое лицо',
                            show: true
                        },
                        inn:      {code: 'inn', label: 'ИНН', value: this.$props.customer.inn, show: (isUL) ? true : false},
                        kpp:      {code: 'kpp', label: 'КПП', value: this.$props.customer.kpp, show: isUL ? true : false},
                        passport: {code: 'passport', label: 'Номер паспорта', value: this.$props.customer.passport_number, show: (!isUL) ? true : false},
                        name: {
                            code: 'name',
                            label: isUL ? 'Наименование' : 'ФИО',
                            value: this.$props.customer.name,
                            show: true
                        },
                        contact:  {code: 'contact',  label: 'Контакт', value: (contacts.join(', ')), show: true},
                        deliveryMethodFrom: {
                            code: 'deliveryMethodFrom',
                            label: 'Способ отправки',
                            value: (parseInt(this.$props.deal.delivery_method_from) == 1 ? 'Со склада' : 'С адреса клиента'),
                            show: (showAddress && this.$props.type == 'sender')
                        },
                        deliveryMethodTo: {
                            code: 'deliveryMethodTo',
                            label: 'Способ доставки',
                            value: (parseInt(this.$props.deal.delivery_method_to) == 1 ? 'До склада' : 'До адреса клиента'),
                            show: (showAddress && this.$props.type == 'recipient')
                        },
                        stockFrom: {
                            code: 'stockFrom',
                            label: 'Склад',
                            value: (this.$props.deal.from_stock) ? this.$props.deal.from_stock.name : '',
                            show: (showAddress && parseInt(this.$props.deal.delivery_method_from) == 1 && this.$props.type == 'sender')
                        },
                        stockTo: {
                            code: 'stockTo',
                            label: 'Склад',
                            value: (this.$props.deal.to_stock) ? this.$props.deal.to_stock.name : '',
                            show: (showAddress && parseInt(this.$props.deal.delivery_method_to) == 1 && this.$props.type == 'recipient')
                        },
                        addressFrom: {
                            code: 'addressFrom',
                            label: 'Адрес',
                            value: (this.$props.deal.from_address) ? this.$props.deal.from_address.address : '',
                            show: (showAddress && parseInt(this.$props.deal.delivery_method_from) == 2 && this.$props.type == 'sender')
                        },
                        addressTo: {
                            code: 'addressTo',
                            label: 'Адрес',
                            value: (this.$props.deal.to_address) ? this.$props.deal.to_address.address : '',
                            show: (showAddress && parseInt(this.$props.deal.delivery_method_to) == 2 && this.$props.type == 'recipient')
                        },
                    }
                };

                return data;
            }
        },
        methods: {}
    }
</script>
<style lang="sass">
    .z-deal-customer-view
        padding: 0 10px
        margin: 0 0 10px 0
        .z-deal-customer-title
            font-size: 14px
            line-height: 16px
            font-weight: bold
            margin: 0 0 5px 0
        .z-deal-customer-view__value
            display: flex
            align-items: center
            justify-content: space-between
            font-size: 12px
            line-height: 14px
            margin: 0 0 8px 0
            .z-deal-customer-view__value-label
                color: #888888
                margin: 0 5px 0 0
                text-align: left
            .z-deal-customer-view__value-value
                color: #000
                text-align: right
</style>


// WEBPACK FOOTER //
// ZDealCustomerView.vue?542ef2ca